/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import styled from 'styled-components';
import { linkCss } from './styles/internal/link';

export const AnchorLink = styled.a`
  ${linkCss}
`;
